module.exports = __webpack_public_path__ + "static/media/loader.2b02159f.gif";